import { createApp } from 'vue';
import RawToPngConverter from '../Components/RawToPngConverter.vue';

const root = document.getElementById('raw-to-png-converter');
if (root) {
  createApp(RawToPngConverter).mount('#raw-to-png-converter');
}
